export default __webpack_public_path__ + "static/media/film.23bfcc33.mp4";